import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { HeadingWithDash } from '../Common/HeadingWithDash'
import { QuoteBox } from './QuoteBox'
import { data } from './data'

const QAContainerFullWidth = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  background-color: #f3f3f3;
`

const QAContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 997px) {
    max-width: 916px;
  }

  swiper-container {
    --swiper-theme-color: #1edba1;
    width: 100%;

    swiper-slide {
      display: flex;
      width: auto;
      height: auto;
    }

    ::part(pagination) {
      position: relative;
      margin-top: 16px;
    }
  }
`

const QuoteBoxesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
`

export const QA = () => {
  const [width, setWidth] = useState(0)

  const swiperElRef = useRef(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWidth(window.innerWidth)

      const handleResize = () => {
        setWidth(window.innerWidth)
      }

      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }

    return null
  }, [])

  return (
    <QAContainerFullWidth>
      <QAContainer>
        <HeadingWithDash text="Les questions fréquentes pour bien préparer son déménagement" />
        {typeof window !== 'undefined' &&
          width !== 0 &&
          (width < 768 ? (
            <swiper-container ref={swiperElRef} slides-per-view="auto" pagination="true" space-between="24px" pagination-clickable="true">
              {data.map(props => (
                <swiper-slide key={props.title}>
                  <QuoteBox key={props.title} {...props} />
                </swiper-slide>
              ))}
            </swiper-container>
          ) : (
            <QuoteBoxesContainer>
              {data.map(props => (
                <QuoteBox key={props.title} {...props} />
              ))}
            </QuoteBoxesContainer>
          ))}
      </QAContainer>
    </QAContainerFullWidth>
  )
}
